import React, {Component} from 'react';
import './referrals-toolbar.css';
import PersonAdd from '@material-ui/icons/PersonAdd';
import { ButtonAddReferral } from 'theme';
class ReferralsToolbar extends Component {
  render() {
    return (
      <div className='toolbarRow'>
        <span className='spacer' />
        <ButtonAddReferral 
          href='/referrals/add'
          size='large'
          fullWidth
        >
          <PersonAdd />
          &nbsp;
          &nbsp;
          Add Referral
        </ButtonAddReferral>
      </div>
    );
  }
}
export default ReferralsToolbar;